<script setup lang="ts">
import TransportEdit from '@/components/transports/TransportEdit.vue';
import TransportsGrid from '@/components/transports/TransportsGrid.vue';
import { RoleGroups } from '@/constants/Roles';
import { historyDataSource } from '@/services/api/transportService';
import { DataSource } from 'devextreme/common/data';

definePage({
  name: 'TransportsHistory',
  meta: {
    title: 'pageTitles.transportHistory',
    roles: RoleGroups.Transports
  }
});

const ds = new DataSource(historyDataSource);

async function refresh(): Promise<void> {
  // Enabling a cancelled transport takes it out of the history.
  await ds.reload();
}
</script>

<template>
  <TransportsGrid :data-source="ds" :read-only="true" :paged="true" />
  <TransportEdit :read-only="true" @update="refresh" />
</template>

<style scoped>

</style>